import { useState } from "react";
import { CheckCircle2, Loader2, ShieldCheck, XCircle } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { btnGhost, errMsg } from "@/components/attendance/ui";

export default function BillingReadiness() {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try { setD((await api.get("/admin/attendance/billing-check")).data); }
    catch (e) { toast.error(errMsg(e, "Check failed")); }
    finally { setBusy(false); }
  };
  const provision = async () => {
    setBusy(true);
    try { const r = await api.post("/admin/attendance/billing-provision"); toast.success(`Subscription prices ready (${r.data.mode})`); await run(); }
    catch (e) { toast.error(errMsg(e, "Could not create prices")); setBusy(false); }
  };
  return (
    <section data-testid="att-billing-readiness">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-3">
        <h3 className="font-serif-display text-2xl text-white flex items-center gap-2"><ShieldCheck size={20} className="text-[#D4AF37]" /> Billing readiness</h3>
        <div className="flex gap-2">
          <button onClick={run} disabled={busy} data-testid="att-billing-check" className={btnGhost}>{busy && <Loader2 size={13} className="animate-spin" />} Run check</button>
          <button onClick={provision} disabled={busy} data-testid="att-billing-provision" className={btnGhost}>Create subscription prices</button>
        </div>
      </div>
      <p className="text-xs text-neutral-500 mb-4">Checks this environment's Stripe key, the Attendance, Hymn Projection and Bundle prices, webhooks and billing portal. In live mode, new subscriptions only open after this check passes on the live site — run it after publishing.</p>
      {d && (
        <div className="luxury-card rounded-xl p-4 space-y-2">
          <div className="text-sm" data-testid="att-billing-summary">
            Mode <span className="text-[#D4AF37] uppercase">{d.mode}</span> · {d.ready ? <span className="text-emerald-300">configuration ready</span> : <span className="text-amber-300">action needed</span>}
            {d.mode === "live" && <> · live billing <span className={d.live_enabled ? "text-emerald-300" : "text-amber-300"}>{d.live_enabled ? "ON" : "OFF"}</span></>}
          </div>
          {d.checks.map((c) => (
            <div key={c.name} className="flex gap-2 text-sm" data-testid={`att-check-${c.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
              {c.ok ? <CheckCircle2 size={16} className="text-emerald-400 shrink-0 mt-0.5" /> : <XCircle size={16} className="text-amber-400 shrink-0 mt-0.5" />}
              <div><span className="text-white">{c.name}</span> <span className="text-neutral-400">— {c.detail}</span></div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
